import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTextStyleItalic = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 12"
    aria-label="IconTextStyleItalic"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M6.018 3.429h1.726L5.844 12H4.118zM7.465 0a.87.87 0 0 0-.482.144.85.85 0 0 0-.318.386.83.83 0 0 0-.05.494.86.86 0 0 0 .932.687.87.87 0 0 0 .635-.378A.857.857 0 0 0 7.465 0" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTextStyleItalic);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
